const HTML_ESCAPE_MAP: {[key: string]: string} = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

export function escapeHtml(value: any, fallback: string = ''): string {
  const text = value === undefined || value === null ? fallback : String(value);
  return text.replace(/[&<>"']/g, (char) => HTML_ESCAPE_MAP[char]);
}

export function joinEscapedHtml(values: any[], separator: string = ', '): string {
  if (!values || !values.length) {
    return '';
  }

  return values.map((value) => escapeHtml(value)).join(separator);
}
